module.exports = __webpack_public_path__ + "media/images/img_plus-sales-cc6e20219add56c47addcd159e902e7e.png";